import { request } from './core.api';

export interface TimelineEventDto {
  id: string;
  tenantId: string;
  tenantName: string;
  title: string;
  titleKey?: string;
  description?: string;
  date: string;
  eventType: string;
  createdAt: string;
}

export interface CreateTimelineEventRequest {
  tenantId: string;
  title: string;
  description?: string;
  date: string;
  eventType: string;
}

export const eventsApi = {
  getByTenant: (tenantId: string) => request<TimelineEventDto[]>(`/tenants/${tenantId}/events`),
  create: (data: CreateTimelineEventRequest) => request<TimelineEventDto>('/events', { method: 'POST', body: JSON.stringify(data) }),
  delete: (id: string) => request<void>(`/events/${id}`, { method: 'DELETE' }),
};
